import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  overflow: hidden;
  background: ${({ theme }) => theme.palette.background.default};
`;

export const Content = styled.div`
  flex: 1;
  padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(2.5)}`};

  overflow: auto;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: 4.8rem;
  padding: ${({ theme }) =>
    `${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(2)} ${theme.spacing(4)}`};

  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};

  color: ${({ theme }) => theme.palette.grey[400]};
`;

export const Title = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.h6)};
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Filters = styled.div`
  display: flex;

  padding: ${({ theme }) => `${theme.spacing(2)}`};

  border-bottom: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  overflow: auto;
`;

export const Filter = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};

  height: 2.6rem;
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
  white-space: nowrap;

  color: ${({ theme }) => theme.palette.text.primary};
`;

export const Badge = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.caption)};
  display: block;

  padding: ${({ theme }) => `0 ${theme.spacing(1.25)}`};

  background: ${({ theme }) =>
    theme.palette.primaryExtended.opacityBackgroundBackground};
  border-radius: ${({ theme }) => theme.spacing(1.5)};

  color: ${({ theme }) => theme.palette.primaryExtended.opacityBackgroundText};
`;
